/* Copyright (c) 2018 Scaper */

import * as cx from "classnames";
import * as React from "react";
import { Button } from "react-materialize";
import { RouteComponentProps, withRouter } from "react-router"
import { Link } from "react-router-dom";
import { BrandName } from "../brand/brandName";
import {
    APP_PATH,
    ABOUT_US_PATH,
    BECOME_A_SCAPER_PATH,
    HOMEOWNERS_PATH,
} from "../paths/pathIndex";

import "./siteNav.scss";

class SiteNavWithoutRouter extends React.Component<RouteComponentProps<any>, {}> {
    public render() {
        return (
            <nav className="scpr-SiteNav">
                <Link
                    className="scpr-SiteNav-home-link"
                    to=""
                >
                    <BrandName />
                </Link>

                <ul className="scpr-SiteNav-left-links">
                    <li className={cx({ "active": this.isActive(ABOUT_US_PATH)})}>
                        <Link to={ABOUT_US_PATH}>About Us</Link>
                    </li>
                    <li className={cx({ "active": this.isActive(HOMEOWNERS_PATH)})}>
                        <Link to={HOMEOWNERS_PATH}>Homeowners</Link>
                    </li>
                </ul>

                <ul>
                    <li className={cx({ "active": this.isActive(BECOME_A_SCAPER_PATH)})}>
                        <Link to={BECOME_A_SCAPER_PATH}>Become a Scaper</Link>
                    </li>
                </ul>

                <Link
                    className="scpr-SiteNav-app-link"
                    to={APP_PATH}
                >
                    <Button waves="light">Go to App</Button>
                </Link>
            </nav>
        );
    }

    private isActive(testPath: string) {
        const { location } = this.props;
        return location.pathname === testPath;
    }
}

export const SiteNav = withRouter(SiteNavWithoutRouter);
